import styled from 'styled-components/macro';
import { Col } from '@yme/atoms/grid';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { HeadingLevel2 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const TitleStyled = styled(HeadingLevel2) `
  margin-bottom: ${INDENT.m};

  ${ADAPTIVE.maxWidth.tablet} {
    ${getTextStyles('Play', 700, 24, 28)}
    margin-bottom: ${INDENT.sm};
  } ;
`;
export const ColStyled = styled(Col) `
  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl'};

  ${ADAPTIVE.maxWidth.mobile} {
    margin-bottom: 16px;
  }

  &:last-child {
    ${ADAPTIVE.maxWidth.mobile} {
      margin-bottom: 0;
    }
  }
`;
